import { Anchor, Breadcrumbs, Grid, Group, Text } from '@mantine/core';
import queryString from 'query-string';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router';
import ErrorMessage from '../../components/ErrorMessage';
import Metadata from '../../components/Metadata';
import PushNotificationForm from '../../components/PushNotifications/PushNotificationForm';
import Spinner from '../../components/Spinner';
import GuidanceModal from '../../components/UserFlows/guidanceModal';
import algorithms from '../../constants/Algorithms';
import { Page } from '../../constants/pageTitles';
import recommenderRules from '../../constants/recommenderRules';
import useFetch from '../../helpers/useFetch';

const page = `${Page['pushNotifications']}`;
const initialPlatforms = ['web'];

const PushNotificationsNewPage = () => {
  const fetch = useFetch();
  const location = useLocation();
  const navigate = useNavigate();

  const [pushNotification, setPushNotification] = useState();
  const [userError, setUserError] = useState();
  const [loadError, setLoadError] = useState();
  const { domain } = useSelector((state) => state.domain);
  const { accountId, domainId } = useParams();
  const [guidanceShow, setGuidanceShow] = useState(false);

  useEffect(() => {
    const from = queryString.parse(location.search).from;
    if (from) {
      fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/pushNotifications/${from}`)
        .then(({ pushNotification }) => {
          pushNotification.name = `Copy of ${pushNotification.name}`;
          delete pushNotification.id;
          setPushNotification(pushNotification);
        })
        .catch(setLoadError);
    } else {
      setPushNotification({
        name: 'New push notification',
        url: domain.url,
        requireInteraction: true,
        renotify: true,
        silent: false,
        tag: 'tag1',
        ttl: 168,
        platforms: initialPlatforms,
        content: initialPlatforms.reduce((accu, platform) => {
          accu[platform] = {
            subject: 'Test push notification',
            body: '',
            btnIconUrl: '',
            btnText: '',
            iconUrl: '',
            imageUrl: '',
          };
          return accu;
        }, {}),
        recommenderConfig: {
          rules: recommenderRules,
          algorithm: Object.keys(algorithms).find(
            (algorithm) =>
              algorithms[algorithm].allowedScopes === undefined ||
              algorithms[algorithm].allowedScopes.includes('viberMessage')
          ),
        },
        type: 'message',
        mobileTargetKV: [{ key: '', value: '' }],
        mobileTarget: null,
        onDailyLimitReached: 'reschedule',
        maxReschedules: 3,
      });
    }
  }, [accountId, domainId, fetch, location.search, domain.url]);

  const create = (push) => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/pushNotifications`, {
      method: 'POST',
      body: JSON.stringify(push),
    })
      .then((response) => {
        setPushNotification(response.pushNotification);
        setGuidanceShow(true);
      })
      .catch(setUserError);
  };

  if (loadError) {
    return <ErrorMessage message={loadError.message} />;
  }

  if (!pushNotification) {
    return <Spinner />;
  }

  const breadcrumbItems = [
    { title: 'Home', href: `#/accounts/${accountId}/domains/${domainId}/analytics` },
    { title: page, href: `#/accounts/${accountId}/domains/${domainId}/push` },
    { title: 'New' },
  ].map((item, index) =>
    item.href ? (
      <Anchor href={item.href} key={index}>
        {item.title}
      </Anchor>
    ) : (
      <Text key={index}>{item.title}</Text>
    )
  );

  return (
    <>
      <Metadata title={`${page} | New`} />
      <Breadcrumbs mb="md">{breadcrumbItems}</Breadcrumbs>
      <GuidanceModal
        type="Push Notification"
        redirect={`/accounts/${accountId}/domains/${domainId}/push`}
        show={guidanceShow}
        elementTypes={['workflows']}
        element={pushNotification}
        setShow={() => setGuidanceShow(false)}
        newElement={true}
      />
      <Grid>
        <Grid.Col span={12}>
          <PushNotificationForm
            pushNotification={pushNotification}
            savePushNotification={(pushNotification) => create(pushNotification)}
            onBack={() => navigate(-1)}
          />
        </Grid.Col>
        {userError ? (
          <Grid.Col span={12}>
            <Group justify="flex-end">
              <ErrorMessage message={userError.message} />
            </Group>
          </Grid.Col>
        ) : null}
      </Grid>
    </>
  );
};

export default PushNotificationsNewPage;
